/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import {
  Typography,
  Link,
  CircularProgress,
  TextField,
  Grid,
  Box,
  Card,
  Avatar,
  Button,
  MenuItem,
  useTheme,
  Collapse,
  IconButton
} from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import GetAppIcon from '@mui/icons-material/GetApp';
// import useAuth from '../../hooks/useAuth';
import { useCallback, useState, useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';
import * as moment from 'moment';
import { relaunchApi } from '../../../api/relaunchApi';
import { ProgressBar } from '../session';
import Label from '../../Label';
import PropTypes from 'prop-types';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, frFR } from '@mui/x-data-grid';
import { alpha } from '@mui/material/styles';
import { Pill } from "../../ui-kit";
import { getProfessionTone, getDocumentTone, getLearnerStatusTone, getRelanceActionTone } from "../../../theme/tones";
import { learnerStatusLabel } from '../../../utils/learnerStatus';

function renderProgress(params) {
  return <ProgressBar value={Number(params.value)} />;
}

const CustomersFollowUpFullScreenTable = (props) => {
  const { rows, allFinanciers = [] } = props;
  const theme = useTheme();
  const mounted = useMounted();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  // const [customers, setCustomers] = useState([]);
  const [numberCustomers, setNumberCustomers] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  // const [rows, setRows] = useState([]);
  const [clickedId, setClickedId] = useState(-1);
  const [showFilters, setShowFilters] = useState(false);

  // Filters
  const [filterLastname, setFilterLastname] = useState('');
  const [filterFirstname, setFilterFirstname] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterPhone, setFilterPhone] = useState('');
  const [filterFormationName, setFilterFormationName] = useState('');
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterEndDate, setFilterEndDate] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterProgression, setFilterProgression] = useState('');
  const [filterAction, setFilterAction] = useState('');
  const [filterProfession, setFilterProfession] = useState('');
  const [filterAgreementSent, setFilterAgreementSent] = useState('');
  const [filterAgreementCompleted, setFilterAgreementCompleted] = useState('');
  const [filterNumberSession, setFilterNumberSession] = useState('');
  const [filterHonorSent, setFilterHonorSent] = useState('');
  const [filterHonorCompleted, setFilterHonorCompleted] = useState('');
  const [filterFormat, setFilterFormat] = useState('');
  const [filterEndKeyDate, setFilterEndKeyDate] = useState('');
  const [filterSessionStartDate, setFilterSessionStartDate] = useState('');
  const [filterFinanceur, setFilterFinanceur] = useState('');

  const activeFiltersCount = [
    filterLastname,
    filterFirstname,
    filterEmail,
    filterPhone,
    filterFormationName,
    filterStartDate,
    filterEndDate,
    filterStatus,
    filterProgression,
    filterAction,
    filterProfession,
    filterAgreementSent,
    filterAgreementCompleted,
    filterNumberSession,
    filterHonorSent,
    filterHonorCompleted,
    filterFormat,
    filterEndKeyDate,
    filterSessionStartDate,
    filterFinanceur
  ].filter((val) => val !== '').length;

  const filteredRows = rows.filter((row) => {
    // String matching for dates
    const startDateMatch = filterStartDate === '' || (row.start_relaunch_date && row.start_relaunch_date.includes(filterStartDate));
    const endKeyDateMatch = filterEndKeyDate === '' || (row.first_turn_end_date && row.first_turn_end_date.includes(filterEndKeyDate));
    const sessionStartDateMatch = filterSessionStartDate === '' || (row.start_date && row.start_date.includes(filterSessionStartDate));

    return (
      (filterLastname === '' || (row.lastname && row.lastname.toLowerCase().includes(filterLastname.toLowerCase()))) &&
      (filterFirstname === '' || (row.firstname && row.firstname.toLowerCase().includes(filterFirstname.toLowerCase()))) &&
      (filterEmail === '' || (row.email && row.email.toLowerCase().includes(filterEmail.toLowerCase()))) &&
      (filterPhone === '' || (row.phone && row.phone.includes(filterPhone))) &&
      (filterFormationName === '' || (row.formation_name && row.formation_name.toLowerCase().includes(filterFormationName.toLowerCase()))) &&
      startDateMatch &&
      sessionStartDateMatch &&
      (filterEndDate === '' || (row.end_date && row.end_date.includes(filterEndDate))) &&
      endKeyDateMatch &&
      (filterStatus === '' || (row.status && learnerStatusLabel(row.status, row.unsubscribed_comment).toLowerCase().includes(filterStatus.toLowerCase()))) &&
      (filterProgression === '' || (row.progression && row.progression.toString().includes(filterProgression))) &&
      (filterAction === '' || (row.action && row.action.toLowerCase().includes(filterAction.toLowerCase()))) &&
      (filterProfession === '' || (row.profession && row.profession.toLowerCase().includes(filterProfession.toLowerCase()))) &&
      (filterAgreementSent === '' || (row.agreementSent && row.agreementSent.toLowerCase().includes(filterAgreementSent.toLowerCase()))) &&
      (filterAgreementCompleted === '' || (row.agreementCompleted && row.agreementCompleted.toLowerCase().includes(filterAgreementCompleted.toLowerCase()))) &&
      (filterNumberSession === '' || (row.numberSession && row.numberSession.toString().includes(filterNumberSession))) &&
      (filterHonorSent === '' || (row.honorSent && row.honorSent.toLowerCase().includes(filterHonorSent.toLowerCase()))) &&
      (filterHonorCompleted === '' || (row.honorCompleted && row.honorCompleted.toLowerCase().includes(filterHonorCompleted.toLowerCase()))) &&
      (filterFormat === '' || (row.format && row.format.toLowerCase().includes(filterFormat.toLowerCase()))) &&
      (filterFinanceur === '' || (row.financeur && row.financeur.toLowerCase().includes(filterFinanceur.toLowerCase())))
    );
  });

  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

  const handleExportCSV = () => {
    const headers = [
      'Civilité', 'Prénom', 'Nom', 'Email', 'Téléphone',
      'Nom de la formation', 'Format', 'N° de programme', 'N° de session',
      'Début de session', 'Fin de session', 'Début relance',
      'Statut', 'Dernière connexion', 'Progression', 'Action', 'Fin de tour clé',
      'Étape', 'Durée', 'Prix', 'Profession', 'Date d\'inscription', 'Source',
      'Convention envoyée', 'Convention signée',
      'Att. Honneur envoyée', 'Att. Honneur signée',
      'Ne pas appeler', 'Financeur'
    ];

    const csvRows = filteredRows.map(row => [
      row.civility || '',
      row.firstname || '',
      row.lastname || '',
      row.email || '',
      row.phone || '',
      row.formation_name || '',
      row.format || '',
      row.programNumber || '',
      row.numberSession || '',
      row.start_date ? `\t${row.start_date}` : '',
      row.end_date ? `\t${row.end_date}` : '',
      row.start_relaunch_date ? `\t${row.start_relaunch_date}` : '',
      learnerStatusLabel(row.status, row.unsubscribed_comment) || '',
      row.last_connection ? `\t${row.last_connection}` : '',
      row.progression || '',
      row.action || '',
      row.first_turn_end_date ? `\t${row.first_turn_end_date}` : '',
      row.step || '',
      row.duration || '',
      row.real_price ? `${row.real_price} EUR` : '',
      row.profession || '',
      row.subscribed_at ? `\t${row.subscribed_at}` : '',
      row.source || '',
      row.agreementSent === 'oui' ? 'Oui' : 'Non',
      row.agreementCompleted === 'oui' ? 'Oui' : 'Non',
      row.honorSent === 'oui' ? 'Oui' : 'Non',
      row.honorCompleted === 'oui' ? 'Oui' : 'Non',
      row.notCall === 'oui' ? 'Oui' : 'Non',
      row.financeur || '',
    ]);

    const csvContent = [headers, ...csvRows]
      .map(row => row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(';'))
      .join('\n');

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Suivi_apprenants_${tenant}_${new Date().toLocaleDateString('fr-FR').replace(/\//g, '-')}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <Button
        size="small"
        startIcon={<GetAppIcon />}
        onClick={handleExportCSV}
        sx={{ fontSize: '0.8rem', textTransform: 'none', fontWeight: 600, ml: 0.5 }}
      >
        Exporter CSV
      </Button>
    </GridToolbarContainer>
  );

  // const getCustomersForFollowUp = useCallback(async () => {
  //   try {
  //     const data = await relaunchApi.getCustomersForFollowUp(localStorage.getItem('accessToken'));
  //     if (data.length === 0) {
  //       throw new Error('Aucun apprenant dans le suivi');
  //     }
  //     if (mounted.current) {
  //       setCustomers(data.customers);
  //       setNumberCustomers(data.numberCustomers.number);
  //       setIsLoading(false);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }, [mounted]);

  // useEffect(() => {
  //   getCustomersForFollowUp();
  // }, [getCustomersForFollowUp]);

  // useEffect(async () => {
  //   setRows(customers.map((item) => ({
  //     id: item.email + item.name,
  //     customerId: item.id,
  //     formationId: item.formation_id,
  //     email: item.email,
  //     phone: item.phone,
  //     profession: item.profession,
  //     firstname: item.firstname,
  //     lastname: item.lastname,
  //     source: item.source,
  //     status: item.status,
  //     last_connection: item.last_connection !== null ? moment(item.last_connection).format('DD/MM/YYYY HH:mm') : '',
  //     start_date: item.start_date !== null ? moment(item.start_date).format('DD/MM/YYYY') : '',
  //     end_date: item.end_date !== null ? moment(item.end_date).format('DD/MM/YYYY') : '',
  //     start_relaunch_date: item.start_relaunch_date !== null ? moment(item.start_relaunch_date).format('DD/MM/YYYY') : '',
  //     first_turn_end_date: item.first_turn_end_date !== null ? moment(item.first_turn_end_date).format('DD/MM/YYYY') : '',
  //     progression: Math.round(item.progression),
  //     formation_name: item.name,
  //     real_price: item.real_price,
  //     civility: item.civility,
  //     action: item.action,
  //     step: item.step,
  //     duration: item.duration,
  //     sessionId: item.session_id,
  //     numberSession: item.number_session,
  //   })));
  // }, [customers]);

  // Couleur de profession : table commune à toutes les listes
  // (src/theme/tones.js), pour qu'« Infirmier » ait la même teinte partout.
  const getProfessionBadge = (profession) => (
    <Pill
      tone={getProfessionTone(profession)}
      label={profession}
      size="small"
      sx={{ mt: 0.5 }}
    />
  );

  const renderDocumentsBadge = (row) => {
    const convSent = row.agreementSent === "oui";
    const convComp = row.agreementCompleted === "oui";
    const honSent = row.honorSent === "oui";
    const honComp = row.honorCompleted === "oui";

    return (
      <Box sx={{ display: "flex", gap: 0.5, flexDirection: "column", py: 0.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Pill
            size="small"
            tone={getDocumentTone(convComp, convSent)}
            label={`Conv : ${convComp ? "Signée" : convSent ? "Envoyée" : "Non envoyée"}`}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Pill
            size="small"
            tone={getDocumentTone(honComp, honSent)}
            label={`Attest : ${honComp ? "Signée" : honSent ? "Envoyée" : "Non envoyée"}`}
          />
        </Box>
      </Box>
    );
  };

  const dateSortComparator = (v1, v2) => {
    const d1 = v1 && v1 !== '-' ? moment(v1, 'DD/MM/YYYY') : null;
    const d2 = v2 && v2 !== '-' ? moment(v2, 'DD/MM/YYYY') : null;
    if (!d1 && !d2) return 0;
    if (!d1) return -1;
    if (!d2) return 1;
    return d1.valueOf() - d2.valueOf();
  };

  const columns = [
    {
      field: '+',
      renderCell: (cellValues) => (
        <IconButton 
          onClick={() => { clickedId === cellValues.row.id ? setClickedId(-1) : setClickedId(cellValues.row.id); }}
          sx={{ color: 'text.secondary' }}
        >
          {cellValues.row.id === clickedId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      ),
      width: 60,
      sortable: false
    },
    {
      field: "lastname",
      headerName: "Apprenant",
      renderCell: (cellValues) => (
        <Box sx={{ py: 1, width: '100%' }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.2 }}>
            <Link
              component={RouterLink}
              to={`/dashboard/customers/${cellValues.row.customerId}`}
              sx={{
                textDecoration: "none",
                fontWeight: 800,
                fontSize: "0.85rem",
                color: "primary.main",
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.3,
                "&:hover": { color: "primary.dark" }
              }}
            >
              {`(${cellValues.row.civility || ""}) ${cellValues.row.firstname} ${cellValues.row.lastname}`}
            </Link>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              {cellValues.row.profession && getProfessionBadge(cellValues.row.profession)}
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                {cellValues.row.phone}
              </Typography>
            </Box>
          </Box>
          <Collapse in={cellValues.row.id === clickedId}>
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: '16px',
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'action.hover',
                width: '100%',
                boxShadow: (theme) => `inset 0 2px 4px ${alpha(theme.palette.common.black, 0.02)}`
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, display: 'block', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    📧 Contacts & Connexions
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      <Box component="span" sx={{ fontWeight: 500, color: 'text.secondary' }}>Email : </Box> {cellValues.row.email || '-'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      <Box component="span" sx={{ fontWeight: 500, color: 'text.secondary' }}>Dernière connexion : </Box> {cellValues.row.last_connection || '-'}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      <Box component="span" sx={{ fontWeight: 500, color: 'text.secondary' }}>Date d'inscription : </Box> {cellValues.row.subscribed_at || '-'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </Box>
      ),
      width: 360,
    },
    {
      field: "formation_name",
      headerName: "Formation & Session",
      renderCell: (cellValues) => (
        <Box sx={{ py: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Link
              component={RouterLink}
              to={`/dashboard/formations/${cellValues.row.formationId}`}
              sx={{
                textDecoration: "none",
                fontWeight: 800,
                fontSize: "0.82rem",
                color: "text.primary",
                "&:hover": { color: "primary.main" },
                whiteSpace: "normal",
                display: "inline-block",
                lineHeight: 1.3
              }}
            >
              {cellValues.row.formation_name}
            </Link>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700 }}>
                Session n° {cellValues.row.numberSession} | Prog. {cellValues.row.programNumber}
              </Typography>
              <Box
                sx={{
                  px: 0.8,
                  py: 0.1,
                  borderRadius: "6px",
                  fontSize: "0.65rem",
                  fontWeight: 800,
                  bgcolor: (theme) => alpha(theme.palette.success.main, 0.08),
                  color: "success.main",
                  border: "1px solid",
                  borderColor: (theme) => alpha(theme.palette.success.main, 0.15),
                  display: "inline-flex",
                  alignItems: "center"
                }}
              >
                {cellValues.row.real_price || 0} €
              </Box>
            </Box>
          </Box>
        </Box>
      ),
      width: 380,
    },
    {
      field: "format",
      headerName: "Format",
      width: 120,
      renderCell: (cellValues) => (
        <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary' }}>
          {cellValues.value || '-'}
        </Typography>
      )
    },
    {
      field: "start_date",
      headerName: "Dates de session",
      renderCell: (cellValues) => (
        <Box sx={{ fontSize: "0.78rem", lineHeight: 1.4, color: "text.primary" }}>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Début : </span>
            {cellValues.row.start_date}
          </div>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Fin : </span>
            {cellValues.row.end_date}
          </div>
        </Box>
      ),
      sortComparator: dateSortComparator,
      width: 150,
    },
    {
      field: "start_relaunch_date",
      headerName: "Dates importantes",
      renderCell: (cellValues) => (
        <Box sx={{ fontSize: "0.78rem", lineHeight: 1.4, color: "text.primary" }}>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Relance : </span>
            {!cellValues.row.start_relaunch_date ? "-" : cellValues.row.start_relaunch_date}
          </div>
          <div>
            <span style={{ fontWeight: 700, color: "text.secondary" }}>Fin U.Clé : </span>
            {!cellValues.row.first_turn_end_date ? "-" : cellValues.row.first_turn_end_date}
          </div>
        </Box>
      ),
      sortComparator: dateSortComparator,
      width: 160,
    },
    {
      field: "status",
      headerName: "Statut & Action",
      // Export et filtre : le motif d'annulation plutôt que « Annulation ».
      valueGetter: (params) => learnerStatusLabel(params.row.status, params.row.unsubscribed_comment),
      renderCell: (cellValues) => (
        // Statut et action de relance : tons issus des tables canoniques
        // (src/theme/tones.js), identiques sur tous les écrans de suivi.
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
          <Pill
            tone={getLearnerStatusTone(cellValues.row.status)}
            label={learnerStatusLabel(cellValues.row.status, cellValues.row.unsubscribed_comment)}
            sx={{ justifyContent: "center" }}
          />
          {cellValues.row.action && (
            <Pill
              tone={getRelanceActionTone(cellValues.row.action)}
              label={cellValues.row.action}
              sx={{ justifyContent: "center" }}
            />
          )}
        </Box>
      ),
      width: 140,
    },
    {
      field: "progression",
      headerName: "Progression",
      renderCell: renderProgress,
      width: 120,
    },
    {
      field: "step",
      headerName: "Étape & Durée",
      renderCell: (cellValues) => (
        <Box sx={{ py: 0.5, fontSize: "0.82rem", lineHeight: 1.5, color: "text.primary", whiteSpace: 'normal', wordBreak: 'break-word' }}>
          <div>
            <Box component="strong" sx={{ color: 'text.primary' }}>Étape : </Box>
            {cellValues.row.step || "-"}
          </div>
          <div style={{ marginTop: '2px' }}>
            <Box component="strong" sx={{ color: 'text.primary' }}>Durée : </Box>
            {cellValues.row.duration || "-"}
          </div>
        </Box>
      ),
      width: 240,
    },
    {
      field: "source",
      headerName: "Source",
      width: 140,
      renderCell: (cellValues) => (
        <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary' }}>
          {cellValues.value || '-'}
        </Typography>
      )
    },
    {
      field: "agreementCompleted",
      headerName: "Convention",
      renderCell: (cellValues) => {
        const sent = cellValues.row.agreementSent === "oui";
        const completed = cellValues.row.agreementCompleted === "oui";

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
            <Pill
              size="small"
              tone={sent ? "blue" : "rose"}
              label={`Envoyée : ${sent ? "Oui" : "Non"}`}
              sx={{ width: "fit-content" }}
            />
            <Pill
              size="small"
              tone={completed ? "emerald" : "rose"}
              label={`Signée : ${completed ? "Oui" : "Non"}`}
              sx={{ width: "fit-content" }}
            />
          </Box>
        );
      },
      width: 140,
    },
    {
      field: "honorCompleted",
      headerName: "Att. Honneur",
      renderCell: (cellValues) => {
        const sent = cellValues.row.honorSent === "oui";
        const completed = cellValues.row.honorCompleted === "oui";

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5 }}>
            <Pill
              size="small"
              tone={sent ? "blue" : "rose"}
              label={`Envoyée : ${sent ? "Oui" : "Non"}`}
              sx={{ width: "fit-content" }}
            />
            <Pill
              size="small"
              tone={completed ? "emerald" : "rose"}
              label={`Signée : ${completed ? "Oui" : "Non"}`}
              sx={{ width: "fit-content" }}
            />
          </Box>
        );
      },
      width: 140,
    },
    {
      field: "financeur",
      headerName: "Financeur",
      width: 200,
      renderCell: (cellValues) => (
        <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary', fontWeight: 600 }}>
          {cellValues.value || '-'}
        </Typography>
      )
    },
  ];
  // const handleCustomers = (async (pageChoice, limitChoice) => {
  //   try {
  //     setIsLoading(true);
  //     const data = await relaunchApi.getCustomersForFollowUp(localStorage.getItem('accessToken'), pageChoice, limitChoice);
  //     setCustomers(data.customers);
  //     setNumberCustomers(data.numberCustomers.number);
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // });

  // const handlePageChange = (event, newPage) => {
  //   setPage(newPage);
  //   handleCustomers(newPage, limit);
  // };

  // const handleLimitChange = (event) => {
  //   setLimit(parseInt(event.target.value, 10));
  //   setPage(0);
  //   handleCustomers(page, parseInt(event.target.value, 10));
  // };

  return (
    <>
      <Box p={3}>
        <Card
          sx={{
            p: 3,
            borderRadius: '24px',
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            backdropFilter: 'blur(20px)',
            boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
            overflow: 'hidden',
          }}
        >
          {/* Header Action Bar */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: activeFiltersCount > 0 ? 'primary.main' : 'action.hover',
                  color: activeFiltersCount > 0 ? 'primary.contrastText' : 'text.secondary',
                  boxShadow: activeFiltersCount > 0 ? (theme) => `0 4px 14px ${alpha(theme.palette.tones.indigo.base, 0.25)}` : 'none',
                  transition: 'all 0.3s ease',
                  width: 42,
                  height: 42,
                  borderRadius: '12px'
                }}
              >
                <FilterAltIcon />
              </Avatar>
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'text.primary', display: 'flex', alignItems: 'center', gap: 1 }}>
                  Recherche & Filtres Avancés
                  {activeFiltersCount > 0 && (
                    <Box
                      sx={{
                        px: 1,
                        py: 0.2,
                        borderRadius: '10px',
                        fontSize: '0.68rem',
                        fontWeight: 800,
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        boxShadow: (theme) => `0 2px 8px ${alpha(theme.palette.tones.indigo.base, 0.35)}`
                      }}
                    >
                      {activeFiltersCount} actif{activeFiltersCount > 1 ? 's' : ''}
                    </Box>
                  )}
                </Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Ajustez les critères pour filtrer la vue détaillée en temps réel
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Button
                onClick={() => {
                  setFilterLastname('');
                  setFilterFirstname('');
                  setFilterEmail('');
                  setFilterPhone('');
                  setFilterFormationName('');
                  setFilterStartDate('');
                  setFilterEndDate('');
                  setFilterStatus('');
                  setFilterProgression('');
                  setFilterAction('');
                  setFilterProfession('');
                  setFilterAgreementSent('');
                  setFilterAgreementCompleted('');
                  setFilterNumberSession('');
                  setFilterHonorSent('');
                  setFilterHonorCompleted('');
                  setFilterFormat('');
                  setFilterEndKeyDate('');
                  setFilterSessionStartDate('');
                  setFilterFinanceur('');
                }}
                disabled={activeFiltersCount === 0}
                variant="text"
                color="inherit"
                startIcon={<RestartAltIcon />}
                sx={{
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  textTransform: 'none',
                  px: 2,
                  py: 1,
                  color: 'text.secondary',
                  '&:hover': {
                    bgcolor: 'action.hover',
                    color: 'error.main'
                  },
                  '&.Mui-disabled': {
                    opacity: 0.4,
                  }
                }}
              >
                Réinitialiser
              </Button>

              <Button
                variant={showFilters ? "contained" : "outlined"}
                onClick={() => setShowFilters(!showFilters)}
                startIcon={showFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  textTransform: 'none',
                  px: 2.5,
                  py: 1,
                  borderWidth: '1.5px',
                  boxShadow: showFilters ? (theme) => `0 4px 12px ${alpha(theme.palette.tones.indigo.base, 0.2)}` : 'none',
                  '&:hover': {
                    borderWidth: '1.5px',
                  }
                }}
              >
                {showFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
              </Button>
            </Box>
          </Box>

          {/* Collapsible Filters Grid */}
          <Collapse in={showFilters} timeout="auto" unmountOnExit>
            <Box sx={{ mt: 3, pt: 3, borderTop: '1px dashed', borderColor: 'divider' }}>
              <Grid container spacing={3}>
                {/* Section 1: Profil Apprenant */}
                <Grid item xs={12} md={6} lg={3}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "18px",
                      border: "1px solid",
                      borderColor: 'divider',
                      backgroundColor: 'action.hover',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: 'primary.main',
                        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.02)}`
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                      <PersonIcon sx={{ color: 'primary.main', fontSize: '1.15rem' }} />
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.72rem' }}>
                        Profil Apprenant
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <TextField fullWidth label="Nom" variant="outlined" value={filterLastname} onChange={(e) => setFilterLastname(e.target.value)} size="small" />
                      <TextField fullWidth label="Prénom" variant="outlined" value={filterFirstname} onChange={(e) => setFilterFirstname(e.target.value)} size="small" />
                      <TextField
                        fullWidth
                        label="Profession"
                        variant="outlined"
                        value={filterProfession}
                        onChange={(e) => setFilterProfession(e.target.value)}
                        select
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="">Toutes</MenuItem>
                        {[...new Set(rows.map(row => row.profession).filter(Boolean))].sort().map((option) => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </TextField>
                      <TextField fullWidth label="Email" variant="outlined" value={filterEmail} onChange={(e) => setFilterEmail(e.target.value)} size="small" />
                      <TextField fullWidth label="Téléphone" variant="outlined" value={filterPhone} onChange={(e) => setFilterPhone(e.target.value)} size="small" />
                    </Box>
                  </Box>
                </Grid>

                {/* Section 2: Formation & Session */}
                <Grid item xs={12} md={6} lg={3}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "18px",
                      border: "1px solid",
                      borderColor: 'divider',
                      backgroundColor: 'action.hover',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: 'primary.main',
                        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.02)}`
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                      <SchoolIcon sx={{ color: 'primary.main', fontSize: '1.15rem' }} />
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.72rem' }}>
                        Session & Formation
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Formation"
                        variant="outlined"
                        value={filterFormationName}
                        onChange={(e) => setFilterFormationName(e.target.value)}
                        select
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                                maxWidth: 500
                              }
                            }
                          }
                        }}
                      >
                        <MenuItem value="">Toutes</MenuItem>
                        {[...new Set(rows.map(row => row.formation_name).filter(Boolean))].sort().map((option) => (
                          <MenuItem key={option} value={option} sx={{ whiteSpace: 'normal', borderBottom: '1px solid', borderColor: 'divider', px: 2, py: 1.25 }}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        label="Format"
                        variant="outlined"
                        value={filterFormat}
                        onChange={(e) => setFilterFormat(e.target.value)}
                        select
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="">Tous</MenuItem>
                        {[...new Set(rows.map(row => row.format).filter(Boolean))].sort().map((option) => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </TextField>
                      <TextField fullWidth label="N° Session" variant="outlined" value={filterNumberSession} onChange={(e) => setFilterNumberSession(e.target.value)} size="small" />
                      <TextField
                        fullWidth
                        label="Financeur"
                        variant="outlined"
                        value={filterFinanceur}
                        onChange={(e) => setFilterFinanceur(e.target.value)}
                        select
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="">Tous</MenuItem>
                        {allFinanciers.length > 0 ? (
                          allFinanciers.map((option) => (
                            <MenuItem key={option.name} value={option.name}>{option.name}</MenuItem>
                          ))
                        ) : (
                          [...new Set(rows.map(row => row.financeur).filter(Boolean))].sort().map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                          ))
                        )}
                      </TextField>
                    </Box>
                  </Box>
                </Grid>

                {/* Section 3: Calendrier & Dates */}
                <Grid item xs={12} md={6} lg={3}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "18px",
                      border: "1px solid",
                      borderColor: 'divider',
                      backgroundColor: 'action.hover',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: 'primary.main',
                        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.02)}`
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                      <CalendarTodayIcon sx={{ color: 'primary.main', fontSize: '1.15rem' }} />
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.72rem' }}>
                        Calendrier & Dates
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Début de session"
                        variant="outlined"
                        value={filterSessionStartDate}
                        onChange={(e) => setFilterSessionStartDate(e.target.value)}
                        size="small"
                        placeholder="DD/MM/YYYY"
                      />
                      <TextField
                        fullWidth
                        label="Fin Session"
                        variant="outlined"
                        value={filterEndDate}
                        onChange={(e) => setFilterEndDate(e.target.value)}
                        size="small"
                        placeholder="DD/MM/YYYY"
                      />
                      <TextField
                        fullWidth
                        label="Début relance"
                        variant="outlined"
                        value={filterStartDate}
                        onChange={(e) => setFilterStartDate(e.target.value)}
                        size="small"
                        placeholder="DD/MM/YYYY"
                      />
                      <TextField
                        fullWidth
                        label="Fin de tour clé"
                        variant="outlined"
                        value={filterEndKeyDate}
                        onChange={(e) => setFilterEndKeyDate(e.target.value)}
                        size="small"
                        placeholder="DD/MM/YYYY"
                      />
                    </Box>
                  </Box>
                </Grid>

                {/* Section 4: Suivi & Documents */}
                <Grid item xs={12} md={6} lg={3}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "18px",
                      border: "1px solid",
                      borderColor: 'divider',
                      backgroundColor: 'action.hover',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: 'primary.main',
                        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.02)}`
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                      <AssignmentIcon sx={{ color: 'primary.main', fontSize: '1.15rem' }} />
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.72rem' }}>
                        Suivi & Documents
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Statut"
                            variant="outlined"
                            value={filterStatus}
                            onChange={(e) => setFilterStatus(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Tous</MenuItem>
                            {['Inscrit', 'InscritD', 'À décaler', 'Annulation', 'En attente', 'Décalé'].map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Progression"
                            variant="outlined"
                            value={filterProgression}
                            onChange={(e) => setFilterProgression(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Toutes</MenuItem>
                            {['0', '25', '50', '75', '100'].map((option) => (
                              <MenuItem key={option} value={option}>{option}%</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>

                      <TextField
                        fullWidth
                        label="Action"
                        variant="outlined"
                        value={filterAction}
                        onChange={(e) => setFilterAction(e.target.value)}
                        select
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="">Toutes</MenuItem>
                        {[...new Set(rows.map(row => row.action).filter(Boolean))].sort().map((option) => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </TextField>

                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Conv. Env."
                            variant="outlined"
                            value={filterAgreementSent}
                            onChange={(e) => setFilterAgreementSent(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Tous</MenuItem>
                            <MenuItem value="oui">Oui</MenuItem>
                            <MenuItem value="non">Non</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Conv. Sig."
                            variant="outlined"
                            value={filterAgreementCompleted}
                            onChange={(e) => setFilterAgreementCompleted(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Tous</MenuItem>
                            <MenuItem value="oui">Oui</MenuItem>
                            <MenuItem value="non">Non</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>

                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Hon. Env."
                            variant="outlined"
                            value={filterHonorSent}
                            onChange={(e) => setFilterHonorSent(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Tous</MenuItem>
                            <MenuItem value="oui">Oui</MenuItem>
                            <MenuItem value="non">Non</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Hon. Sig."
                            variant="outlined"
                            value={filterHonorCompleted}
                            onChange={(e) => setFilterHonorCompleted(e.target.value)}
                            select
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          >
                            <MenuItem value="">Tous</MenuItem>
                            <MenuItem value="oui">Oui</MenuItem>
                            <MenuItem value="non">Non</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </Card>
      </Box>
      <Box sx={{ px: 3, pb: 3 }}>
        <DataGrid
          density="comfortable"
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          initialState={{
            sorting: {
              sortModel: [{ field: 'lastname', sort: 'asc' }],
            },
          }}
          autoHeight
          rowHeight={90}
          getRowHeight={({ id, densityFactor }) => {
            if (id === clickedId) {
              return 320 * densityFactor;
            }
            return null;
          }}
          rows={filteredRows}
          columns={columns}
          pageSize={25}
          rowsPerPageOptions={[5, 10, 25, 50]}
          components={{ Toolbar: CustomToolbar }}
          sx={{
            border: 'none',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'action.hover',
              borderBottom: `1px solid ${theme.palette.divider}`,
              borderRadius: '12px',
              fontWeight: 700
            },
            '& .MuiDataGrid-columnHeader': {
              color: 'text.secondary',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid',
              borderBottomColor: 'divider',
              color: 'text.primary',
              fontSize: '0.85rem'
            },
            '& .MuiDataGrid-cell[data-field="formation_name"]': {
              whiteSpace: 'normal !important',
              lineHeight: '1.3 !important',
              display: 'flex !important',
              alignItems: 'center !important',
              py: '8px !important',
              width: '100% !important'
            },
            '& .MuiDataGrid-cell[data-field="lastname"]': {
              whiteSpace: 'normal !important',
              overflow: 'hidden !important',
              alignItems: 'flex-start !important',
              paddingTop: '8px !important',
            },
            '& .MuiDataGrid-cell[data-field="step"]': {
              whiteSpace: 'normal !important',
              overflow: 'hidden !important',
              alignItems: 'center !important',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'action.hover',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: 'none'
            }
          }}
        />
      </Box>
    </>
  );
};

CustomersFollowUpFullScreenTable.propTypes = {
  rows: PropTypes.array.isRequired,
  allFinanciers: PropTypes.array,
};

export default CustomersFollowUpFullScreenTable;
